"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getRootEntry = getRootEntry;
exports.getEntryByKey = getEntryByKey;
exports.getEntryByPath = getEntryByPath;
exports.getChecksumOfFootprints = getChecksumOfFootprints;
exports.getDescendants = getDescendants;
exports.modelCanRun = modelCanRun;
exports.convertTo2011Euro = convertTo2011Euro;
exports.carbonEmissionOfLineItem = carbonEmissionOfLineItem;
exports.carbonEmissions = carbonEmissions;
exports.modelCanRunVersion = exports.modelVersion = exports.modelName = exports.purchaseIcon = exports.ENTRY_BY_KEY = exports.explanation = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _definitions = require("../../definitions");

var _currency = require("../../integrations/utils/currency/currency");

var _utils = require("../utils");

var _exchange_rates_ = _interopRequireDefault(require("./exchange_rates_2011.json"));

var _footprints = require("./footprints");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var consumerPriceIndex = {
  countries: {
    AU: {
      "2011": 92.2,
      "2012": 93.8,
      "2013": 96.1,
      "2014": 98.5,
      "2015": 100,
      "2016": 101.3,
      "2017": 103.3,
      "2018": 105.2,
      "2019": 106.9
    },
    AT: {
      "2011": 93.3,
      "2012": 95.6,
      "2013": 97.6,
      "2014": 99.1,
      "2015": 100,
      "2016": 100.9,
      "2017": 103,
      "2018": 105.1,
      "2019": 106.7,
      "2020": 107.8
    },
    BE: {
      "2011": 95.3,
      "2012": 98,
      "2013": 99.1,
      "2014": 99.4,
      "2015": 100,
      "2016": 102,
      "2017": 104.1,
      "2018": 106.3,
      "2019": 107.8,
      "2020": 108.7
    },
    CA: {
      "2011": 94.7,
      "2012": 96.1,
      "2013": 97,
      "2014": 98.9,
      "2015": 100,
      "2016": 101.4,
      "2017": 103,
      "2018": 105.4,
      "2019": 107.4,
      "2020": 108.2
    },
    CL: {
      "2011": 87.3,
      "2012": 89.9,
      "2013": 91.5,
      "2014": 95.8,
      "2015": 100,
      "2016": 103.8,
      "2017": 106.1,
      "2018": 108.6,
      "2019": 111.4,
      "2020": 114
    },
    CZ: {
      "2011": 94.8,
      "2012": 97.9,
      "2013": 99.3,
      "2014": 99.7,
      "2015": 100,
      "2016": 100.7,
      "2017": 103.1,
      "2018": 105.3,
      "2019": 108.3,
      "2020": 111.2
    },
    DK: {
      "2011": 95.9,
      "2012": 98.2,
      "2013": 99,
      "2014": 99.6,
      "2015": 100,
      "2016": 100.3,
      "2017": 101.4,
      "2018": 102.2,
      "2019": 103,
      "2020": 103.3
    },
    EE: {
      "2011": 94.2,
      "2012": 97.9,
      "2013": 100.6,
      "2014": 100.5,
      "2015": 100,
      "2016": 100.1,
      "2017": 103.6,
      "2018": 107.1,
      "2019": 109.6,
      "2020": 109.5
    },
    FI: {
      "2011": 95.1,
      "2012": 97.7,
      "2013": 99.2,
      "2014": 100.2,
      "2015": 100,
      "2016": 100.4,
      "2017": 101.1,
      "2018": 102.2,
      "2019": 103.3,
      "2020": 103.5
    },
    FR: {
      "2011": 96.7,
      "2012": 98.6,
      "2013": 99.5,
      "2014": 100,
      "2015": 100,
      "2016": 100.2,
      "2017": 101.2,
      "2018": 103.1,
      "2019": 104.2,
      "2020": 104.6
    },
    DE: {
      "2011": 95.2,
      "2012": 97.1,
      "2013": 98.6,
      "2014": 99.5,
      "2015": 100,
      "2016": 100.5,
      "2017": 102,
      "2018": 103.8,
      "2019": 105.3,
      "2020": 105.5
    },
    GR: {
      "2011": 102.5,
      "2012": 104.1,
      "2013": 103.1,
      "2014": 101.8,
      "2015": 100,
      "2016": 99.2,
      "2017": 100.3,
      "2018": 100.9,
      "2019": 101.2,
      "2020": 100.6
    },
    HU: {
      "2011": 93.3,
      "2012": 98.6,
      "2013": 100.3,
      "2014": 100.1,
      "2015": 100,
      "2016": 100.4,
      "2017": 102.8,
      "2018": 105.7,
      "2019": 109.2,
      "2020": 112
    },
    IS: {
      "2011": 88.3,
      "2012": 92.8,
      "2013": 96.4,
      "2014": 98.4,
      "2015": 100,
      "2016": 101.7,
      "2017": 103.5,
      "2018": 106.3,
      "2019": 109.5,
      "2020": 110.5
    },
    IE: {
      "2011": 97.9,
      "2012": 99.6,
      "2013": 100.1,
      "2014": 100.3,
      "2015": 100,
      "2016": 100,
      "2017": 100.3,
      "2018": 100.8,
      "2019": 101.8,
      "2020": 101.9
    },
    IL: {
      "2011": 97,
      "2012": 98.6,
      "2013": 100.2,
      "2014": 100.6,
      "2015": 100,
      "2016": 99.5,
      "2017": 99.7,
      "2018": 100.5,
      "2019": 101.4,
      "2020": 101
    },
    IT: {
      "2011": 95.6,
      "2012": 98.5,
      "2013": 99.7,
      "2014": 99.9,
      "2015": 100,
      "2016": 99.9,
      "2017": 101.1,
      "2018": 102.3,
      "2019": 102.9,
      "2020": 102.9
    },
    JP: {
      "2011": 96.3,
      "2012": 96.2,
      "2013": 96.6,
      "2014": 99.2,
      "2015": 100,
      "2016": 99.9,
      "2017": 100.4,
      "2018": 101.3,
      "2019": 101.8,
      "2020": 102
    },
    KR: {
      "2011": 94.7,
      "2012": 96.8,
      "2013": 98,
      "2014": 99.3,
      "2015": 100,
      "2016": 101,
      "2017": 102.9,
      "2018": 104.5,
      "2019": 104.9,
      "2020": 105.7
    },
    LV: {
      "2011": 97,
      "2012": 99.2,
      "2013": 99.2,
      "2014": 99.8,
      "2015": 100,
      "2016": 100.1,
      "2017": 103.1,
      "2018": 105.7,
      "2019": 108.7,
      "2020": 109.4
    },
    LT: {
      "2011": 96.8,
      "2012": 99.7,
      "2013": 100.8,
      "2014": 100.9,
      "2015": 100,
      "2016": 100.9,
      "2017": 104.7,
      "2018": 107.5,
      "2019": 110,
      "2020": 111.4
    },
    LU: {
      "2011": 94.7,
      "2012": 97.2,
      "2013": 98.9,
      "2014": 99.5,
      "2015": 100,
      "2016": 100.3,
      "2017": 102,
      "2018": 103.6,
      "2019": 105.4,
      "2020": 106.1
    },
    MX: {
      "2011": 86.6,
      "2012": 90.2,
      "2013": 93.6,
      "2014": 97.4,
      "2015": 100,
      "2016": 102.8,
      "2017": 109,
      "2018": 114.4,
      "2019": 118.5,
      "2020": 121.8
    },
    NL: {
      "2011": 93.7,
      "2012": 96,
      "2013": 98.4,
      "2014": 99.4,
      "2015": 100,
      "2016": 100.3,
      "2017": 101.7,
      "2018": 103.4,
      "2019": 106.2,
      "2020": 106.5
    },
    NZ: {
      "2011": 96.4,
      "2012": 97.4,
      "2013": 98.5,
      "2014": 99.7,
      "2015": 100,
      "2016": 100.6,
      "2017": 102.5,
      "2018": 104.1,
      "2019": 105.8
    },
    NO: {
      "2011": 93.3,
      "2012": 93.9,
      "2013": 95.9,
      "2014": 97.9,
      "2015": 100,
      "2016": 103.6,
      "2017": 105.5,
      "2018": 108.4,
      "2019": 110.8,
      "2020": 111.2
    },
    PL: {
      "2011": 96.4,
      "2012": 99.8,
      "2013": 100.8,
      "2014": 100.9,
      "2015": 100,
      "2016": 99.3,
      "2017": 101.4,
      "2018": 103.2,
      "2019": 105.5,
      "2020": 108.7
    },
    PT: {
      "2011": 96.8,
      "2012": 99.5,
      "2013": 99.8,
      "2014": 99.5,
      "2015": 100,
      "2016": 100.6,
      "2017": 102,
      "2018": 103,
      "2019": 103.3,
      "2020": 102.8
    },
    SK: {
      "2011": 95.6,
      "2012": 99,
      "2013": 100.4,
      "2014": 100.3,
      "2015": 100,
      "2016": 99.5,
      "2017": 100.8,
      "2018": 103.3,
      "2019": 106.1,
      "2020": 107.9
    },
    SI: {
      "2011": 96.1,
      "2012": 98.6,
      "2013": 100.3,
      "2014": 100.5,
      "2015": 100,
      "2016": 99.9,
      "2017": 101.4,
      "2018": 103.1,
      "2019": 104.8,
      "2020": 104.6
    },
    ES: {
      "2011": 96.9,
      "2012": 99.3,
      "2013": 100.7,
      "2014": 100.5,
      "2015": 100,
      "2016": 99.8,
      "2017": 101.7,
      "2018": 103.5,
      "2019": 104.2,
      "2020": 103.8
    },
    SE: {
      "2011": 99.4,
      "2012": 100.3,
      "2013": 100.2,
      "2014": 100,
      "2015": 100,
      "2016": 101,
      "2017": 102.8,
      "2018": 104.8,
      "2019": 106.7,
      "2020": 106.5
    },
    CH: {
      "2011": 102.1,
      "2012": 101.4,
      "2013": 101.2,
      "2014": 101.2,
      "2015": 100,
      "2016": 99.6,
      "2017": 100.1,
      "2018": 101,
      "2019": 101.4,
      "2020": 101
    },
    TR: {
      "2011": 72.9,
      "2012": 79.4,
      "2013": 85.3,
      "2014": 92.9,
      "2015": 100,
      "2016": 107.8,
      "2017": 119.8,
      "2018": 139.3,
      "2019": 160.5,
      "2020": 172.1
    },
    GB: {
      "2011": 93.6,
      "2012": 96,
      "2013": 98.2,
      "2014": 99.6,
      "2015": 100,
      "2016": 101,
      "2017": 103.6,
      "2018": 106,
      "2019": 107.8,
      "2020": 108.5
    },
    US: {
      "2011": 94.9,
      "2012": 96.9,
      "2013": 98.3,
      "2014": 99.9,
      "2015": 100,
      "2016": 101.3,
      "2017": 103.4,
      "2018": 105.9,
      "2019": 107.9,
      "2020": 109
    },
    BR: {
      "2011": 77.1,
      "2012": 81.2,
      "2013": 86.3,
      "2014": 91.7,
      "2015": 100,
      "2016": 108.7,
      "2017": 112.5,
      "2018": 116.6,
      "2019": 121,
      "2020": 123.9
    },
    CN: {
      "2011": 91.8,
      "2012": 94.3,
      "2013": 96.7,
      "2014": 98.6,
      "2015": 100,
      "2016": 102,
      "2017": 103.6,
      "2018": 105.8,
      "2019": 108.8,
      "2020": 112.9
    },
    CO: {
      "2011": 87.9,
      "2012": 90.7,
      "2013": 92.6,
      "2014": 95.2,
      "2015": 100,
      "2016": 107.5,
      "2017": 112.2,
      "2018": 115.8,
      "2019": 119.9,
      "2020": 122.6
    },
    CR: {
      "2011": 86.3,
      "2012": 90.2,
      "2013": 94.9,
      "2014": 99.2,
      "2015": 100,
      "2016": 100,
      "2017": 101.6,
      "2018": 103.9,
      "2019": 106,
      "2020": 106.9
    },
    IN: {
      "2011": 73.3,
      "2012": 80.1,
      "2013": 88.8,
      "2014": 94.5,
      "2015": 100,
      "2016": 104.9,
      "2017": 107.6,
      "2018": 112.8,
      "2019": 121.4,
      "2020": 125.9
    },
    ID: {
      "2011": 79.6,
      "2012": 83,
      "2013": 88.4,
      "2014": 94,
      "2015": 100,
      "2016": 103.5,
      "2017": 107.5,
      "2018": 110.9,
      "2019": 114.3,
      "2020": 116.1
    },
    RU: {
      "2011": 71.6,
      "2012": 75.2,
      "2013": 80.3,
      "2014": 86.6,
      "2015": 100,
      "2016": 107,
      "2017": 111,
      "2018": 114.2,
      "2019": 119.3,
      "2020": 121.2
    },
    SA: {
      "2011": 90.7,
      "2012": 93.3,
      "2013": 96.6,
      "2014": 98.8,
      "2015": 100,
      "2016": 102.1,
      "2017": 101.2,
      "2018": 103.7,
      "2019": 101.5,
      "2020": 102.3
    },
    ZA: {
      "2011": 80.6,
      "2012": 85.2,
      "2013": 90.2,
      "2014": 95.7,
      "2015": 100,
      "2016": 106.6,
      "2017": 112.1,
      "2018": 117.2,
      "2019": 122,
      "2020": 125
    }
  },
  average: {
    "2011": 92.05333333333334,
    "2012": 94.73333333333332,
    "2013": 96.82666666666668,
    "2014": 98.55555555555556,
    "2015": 100,
    "2016": 101.64222222222226,
    "2017": 103.9488888888889,
    "2018": 106.61555555555553,
    "2019": 109.20888888888891,
    "2020": 110.72093023255815
  }
};
var AVERAGE_CPI_COUNTRY_INDICATOR = 'average';
var COUNTRY_CPI_INDICATOR = 'countries';
var explanation = {
  text: null,
  links: [{
    label: 'Tomorrow footprint database',
    href: 'https://github.com/tmrowco/bloom-contrib/blob/master/co2eq/purchase/footprints.yml'
  }]
};
exports.explanation = explanation;
var ENTRY_BY_KEY = {};
exports.ENTRY_BY_KEY = ENTRY_BY_KEY;
var purchaseIcon = {}; // Traverse and index tree

exports.purchaseIcon = purchaseIcon;

function indexNodeChildren(branch) {
  var i = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
  Object.entries(branch._children || []).forEach(function (_ref) {
    var _ref2 = (0, _slicedToArray2["default"])(_ref, 2),
        k = _ref2[0],
        v = _ref2[1];

    if (ENTRY_BY_KEY[k]) {
      throw new Error("Error while indexing footprint tree: There's already an entry for ".concat(k));
    }

    ENTRY_BY_KEY[k] = v;
    purchaseIcon[k] = v.icon; // Also make sure we add additional props

    v.key = k;
    v.level = i;
    v.parentKey = branch.key; // Traverse further

    indexNodeChildren(v, i + 1);
  });
}

indexNodeChildren(_footprints.footprints);

function getRootEntry() {
  return _footprints.footprints;
}

function getEntryByKey(key) {
  return ENTRY_BY_KEY[key];
}

function getEntryByPath(path) {
  var entry = _footprints.footprints; // root node

  for (var i = 0; i < path.length; i += 1) {
    entry = (entry._children || {})[path[i]];
  }

  return entry;
}

function getChecksumOfFootprints() {
  return (0, _utils.getChecksum)(_footprints.footprints);
}

function getDescendants(entry) {
  var filter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function (_) {
    return true;
  };
  var includeRoot = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

  // Note: `getDescendants` is very close to `indexNodeChildren`
  // Note2: if a node gets filtered out, its children won't be visited
  if (!entry) {
    throw new Error('Invalid `entry`');
  }

  var descendants = includeRoot ? (0, _defineProperty2["default"])({}, entry.key, entry) : {};
  Object.values(entry._children || []).filter(filter).forEach(function (child) {
    descendants = _objectSpread({}, descendants, {}, getDescendants(child, filter, true));
  });
  return descendants;
} // ** modelName must not be changed. If changed then old activities will not be re-calculated **


var modelName = 'purchase';
exports.modelName = modelName;
var modelVersion = "9_".concat(getChecksumOfFootprints()); // This model relies on footprints.yaml

exports.modelVersion = modelVersion;
var modelCanRunVersion = 1;
exports.modelCanRunVersion = modelCanRunVersion;

function modelCanRun(activity) {
  var costAmount = activity.costAmount,
      costCurrency = activity.costCurrency,
      activityType = activity.activityType,
      transportationMode = activity.transportationMode,
      lineItems = activity.lineItems;

  if (costAmount && costCurrency) {
    if (activityType === _definitions.ACTIVITY_TYPE_MEAL) {
      return true;
    }

    if (activityType === _definitions.ACTIVITY_TYPE_TRANSPORTATION) {
      switch (transportationMode) {
        case _definitions.TRANSPORTATION_MODE_CAR:
        case _definitions.TRANSPORTATION_MODE_FERRY:
        case _definitions.TRANSPORTATION_MODE_OTHER_TRANSPORT:
        case _definitions.TRANSPORTATION_MODE_PLANE:
        case _definitions.TRANSPORTATION_MODE_PUBLIC_TRANSPORT:
        case _definitions.TRANSPORTATION_MODE_TRAIN:
          return true;

        default:
          return false;
      }
    }

    if (_definitions.ELECTRICITY_ACTIVITIES.includes(activityType)) {
      return true;
    }
  }

  var hasLineItems = lineItems && lineItems.length > 0;
  var hasIdentifiers = lineItems && lineItems.every(function (item) {
    return item.identifier;
  });

  if (activityType === _definitions.ACTIVITY_TYPE_PURCHASE && hasLineItems && hasIdentifiers) {
    return true;
  }

  return false;
}

function correctWithParticipants(footprint, participants) {
  return footprint / (participants || 1);
}

function convertTo2011Euro(amount, currency) {
  var exchangeRate2011 = _exchange_rates_["default"].rates[currency.toUpperCase()];

  if (exchangeRate2011 == null) {
    throw new Error("Unknown currency '".concat(currency, "'"));
  }

  return amount / exchangeRate2011;
}

function extractEur(_ref4) {
  var costAmount = _ref4.costAmount,
      costCurrency = _ref4.costCurrency;
  return costAmount && costCurrency ? convertTo2011Euro(costAmount, costCurrency) : null;
}

function conversionCPI(eurAmount, referenceYear, countryCodeISO2, datetime) {
  if (!eurAmount || !datetime) {
    return eurAmount;
  }

  if (!referenceYear) {
    throw new Error("Missing consumer price index reference year");
  }

  var currentDateIndicator = datetime.getFullYear();
  var CPIcurrent;

  if (countryCodeISO2 && consumerPriceIndex[COUNTRY_CPI_INDICATOR][countryCodeISO2][currentDateIndicator]) {
    CPIcurrent = consumerPriceIndex[COUNTRY_CPI_INDICATOR][countryCodeISO2][currentDateIndicator];
  } else if (consumerPriceIndex[AVERAGE_CPI_COUNTRY_INDICATOR][currentDateIndicator]) {
    CPIcurrent = consumerPriceIndex[AVERAGE_CPI_COUNTRY_INDICATOR][currentDateIndicator];
  } else {
    throw new Error("Unknown CPI for activity date ".concat(datetime));
  }

  var CPIreference;

  if (countryCodeISO2 && consumerPriceIndex[COUNTRY_CPI_INDICATOR][countryCodeISO2][referenceYear]) {
    CPIreference = consumerPriceIndex[COUNTRY_CPI_INDICATOR][countryCodeISO2][referenceYear];
  } else if (consumerPriceIndex[AVERAGE_CPI_COUNTRY_INDICATOR][referenceYear]) {
    CPIreference = consumerPriceIndex[AVERAGE_CPI_COUNTRY_INDICATOR][referenceYear];
  } else {
    throw new Error("Unknown CPI for reference year ".concat(referenceYear));
  } // ref: https://www.investopedia.com/terms/c/consumerpriceindex.asp


  var eurAmountAdjusted = eurAmount * (CPIreference / CPIcurrent);
  return eurAmountAdjusted;
}
/**
 * Returns the compatible unit and amounts of a line item
 * @param {*} lineItem - Object of the the type { name: <string>, unit: <string>, value: <string>, costAmount: <float>, costCurrency: <string> }
 * @param {*} entry - A purchase entry
 * @param {*} countryCodeISO2 - country code of the activity
 * @param {*} datetime - datetime of the activity
 */


function extractCompatibleUnitAndAmount(lineItem, entry, countryCodeISO2, datetime) {
  var isMonetaryItem = (0, _currency.getAvailableCurrencies)().includes(lineItem.unit); // Extract eurAmount if applicable

  var eurAmount = extractEur({
    costCurrency: isMonetaryItem ? lineItem.unit : null,
    costAmount: isMonetaryItem ? lineItem.value : null
  });

  if (eurAmount) {
    eurAmount = conversionCPI(eurAmount, entry.year, countryCodeISO2, datetime);
  }

  var availableEntryUnit = entry.unit;

  if (availableEntryUnit === _definitions.UNIT_LITER && lineItem.unit === _definitions.UNIT_LITER) {
    return {
      unit: _definitions.UNIT_LITER,
      amount: lineItem.value
    };
  }

  if (availableEntryUnit === _definitions.UNIT_KILOGRAMS && lineItem.unit === _definitions.UNIT_KILOGRAMS) {
    return {
      unit: _definitions.UNIT_KILOGRAMS,
      amount: lineItem.value
    };
  }

  if (availableEntryUnit === _definitions.UNIT_MONETARY_EUR && eurAmount != null) {
    return {
      unit: _definitions.UNIT_MONETARY_EUR,
      amount: eurAmount
    };
  }

  if (availableEntryUnit === _definitions.UNIT_ITEM) {
    return {
      unit: _definitions.UNIT_ITEM,
      amount: 1
    };
  }

  throw new Error("Line item of activity has no compatible purchase unit.");
}
/**
 * Calculates the carbon emissions of a line item entry
 * @param {*} lineItem - Object of the the type { identifier: <string>, unit: <string>, value: <string>, costAmount: <float>, costCurrency: <string> }
 * @param {*} countryCodeISO2 - country code of the activity
 * @param {*} datetime - datetime of the activity
 */


function carbonEmissionOfLineItem(lineItem, countryCodeISO2, datetime) {
  // The generic identifier property holds the purchaseType value, so rename to make clear..
  var identifier = lineItem.identifier;
  var entry = getEntryByKey(identifier);

  if (!entry) {
    throw new Error("Unknown purchaseType identifier: ".concat(identifier));
  }

  if (!entry.intensityKilograms) {
    throw new Error("Missing carbon intensity for purchaseType: ".concat(identifier));
  }

  var _extractCompatibleUni = extractCompatibleUnitAndAmount(lineItem, entry, countryCodeISO2, datetime),
      unit = _extractCompatibleUni.unit,
      amount = _extractCompatibleUni.amount;

  if (unit == null || amount == null || !Number.isFinite(amount)) {
    throw new Error("Invalid unit ".concat(unit, " or amount ").concat(amount, " for purchaseType ").concat(identifier, ". Expected ").concat(entry.unit));
  }

  if (entry.unit !== unit) {
    throw new Error("Invalid unit ".concat(unit, " given for purchaseType ").concat(identifier, ". Expected ").concat(entry.unit));
  }

  if (typeof entry.intensityKilograms === 'number') {
    return entry.intensityKilograms * amount;
  }

  if (entry.unit !== _definitions.UNIT_MONETARY_EUR) {
    throw new Error("Invalid unit ".concat(entry.unit, " given. Expected ").concat(_definitions.UNIT_MONETARY_EUR));
  }

  if (!countryCodeISO2) {
    // Use average of all countries
    // TODO: weight by the GDP of countries or by population
    var values = Object.values(entry.intensityKilograms);
    return values.reduce(function (a, b) {
      return a + b;
    }, 0) / values.length * amount;
  }

  if (!entry.intensityKilograms[countryCodeISO2]) {
    throw new Error("Missing carbon intensity for country ".concat(countryCodeISO2, " and identifier ").concat(identifier));
  }

  return entry.intensityKilograms[countryCodeISO2] * amount;
}
/*
  Carbon emissions of an activity (in kgCO2eq)
*/


function carbonEmissions(activity) {
  var footprint;

  switch (activity.activityType) {
    case _definitions.ACTIVITY_TYPE_MEAL:
      footprint = carbonEmissionOfLineItem({
        identifier: _definitions.PURCHASE_CATEGORY_FOOD_SERVING_SERVICES,
        unit: activity.costCurrency,
        value: activity.costAmount
      }, activity.countryCodeISO2, activity.datetime);
      break;

    case _definitions.ACTIVITY_TYPE_TRANSPORTATION:
      {
        var identifier;

        switch (activity.transportationMode) {
          case _definitions.TRANSPORTATION_MODE_CAR:
            identifier = _definitions.PURCHASE_CATEGORY_TRANSPORT_ROAD; // Taxi bill

            break;

          case _definitions.TRANSPORTATION_MODE_TRAIN:
            identifier = _definitions.PURCHASE_CATEGORY_TRANSPORT_RAIL;
            break;

          case _definitions.TRANSPORTATION_MODE_PUBLIC_TRANSPORT:
            identifier = _definitions.PURCHASE_CATEGORY_COMBINED_PASSENGER_TRANSPORT;
            break;

          case _definitions.TRANSPORTATION_MODE_OTHER_TRANSPORT:
            identifier = _definitions.PURCHASE_CATEGORY_OTHER_TRANSPORT_SERVICES;
            break;

          case _definitions.TRANSPORTATION_MODE_PLANE:
            identifier = _definitions.PURCHASE_CATEGORY_TRANSPORT_AIR;
            break;

          case _definitions.TRANSPORTATION_MODE_FERRY:
            identifier = _definitions.PURCHASE_CATEGORY_TRANSPORT_BOAT;
            break;

          default:
            throw new Error("Couldn't calculate purchase carbonIntensity for transporation activity with mode ".concat(activity.transportationMode));
        }

        footprint = carbonEmissionOfLineItem({
          identifier: identifier,
          unit: activity.costCurrency,
          value: activity.costAmount
        }, activity.countryCodeISO2, activity.datetime);
        break;
      }

    case _definitions.ACTIVITY_TYPE_ELECTRICITY:
    case _definitions.ACTIVITY_TYPE_ELECTRIC_VEHICLE_CHARGING:
    case _definitions.ACTIVITY_TYPE_ELECTRIC_HEATING:
      {
        footprint = carbonEmissionOfLineItem({
          identifier: _definitions.PURCHASE_CATEGORY_ELECTRICITY,
          unit: activity.costCurrency,
          value: activity.costAmount
        }, activity.countryCodeISO2, activity.datetime);
        break;
      }

    case _definitions.ACTIVITY_TYPE_PURCHASE:
      {
        var lineItems = activity.lineItems,
            countryCodeISO2 = activity.countryCodeISO2,
            datetime = activity.datetime; // First check if lineItems contains and calculate total of all line items

        if (lineItems && lineItems.length) {
          // TODO(df): What to do on a single line error? Abort all? Skip item?
          footprint = lineItems.map(function (l) {
            return carbonEmissionOfLineItem(l, countryCodeISO2, datetime);
          }).reduce(function (a, b) {
            return a + b;
          }, 0);
        }

        break;
      }

    default:
      throw new Error("Couldn't calculate purchase carbonIntensity for activityType: ".concat(activity.activityType));
  }

  return correctWithParticipants(footprint, activity.participants);
}